module.exports = __webpack_public_path__ + "static/media/Idea.7a158bb8.svg";